import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GstarClient,
  UserEmailNotificationSettingsRequest,
  UserEmailNotificationSettingsResponse,
} from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private readonly gstarClient = inject(GstarClient);

  getEmailConfigurationById(
    clientId: string
  ): Observable<UserEmailNotificationSettingsResponse> {
    return this.gstarClient.getuseremailsettings(clientId);
  }

  setEmailConfiguration(
    clientId: string,
    configuration: UserEmailNotificationSettingsRequest
  ): Observable<UserEmailNotificationSettingsResponse> {
    return this.gstarClient.setuseremailsettings(clientId, configuration);
  }
}
